import React from 'react';
import { heroPosChoice } from '../../content/siteMessaging';

const shellClassName =
  'relative mx-auto w-full max-w-[44rem] lg:ml-auto';
const frameClassName =
  'relative aspect-square overflow-hidden rounded-[2rem] shadow-[0_30px_80px_rgba(39,18,9,0.18)] md:aspect-[1659/948]';
const imageClassName =
  'block h-full w-full object-cover';
const proofCardClassName =
  'mt-5 ml-auto max-w-[20rem] rounded-[1.4rem] border border-[#e8c9ae] bg-[#fff3e4] px-5 py-5 text-left shadow-[0_22px_50px_rgba(59,27,13,0.16)]';

export const HeroDeviceCluster: React.FC = () => {
  return (
    <div className={shellClassName}>
      <div className={frameClassName}>
        <picture>
          <source
            media="(min-width: 768px)"
            srcSet="/product/hero/coupling-hero-desktop-blended.jpg"
          />
          <img
            src="/product/hero/coupling-hero-mobile.jpg"
            alt="Coupling hero scene showing merchant checkout on a tablet, the customer app on phones, and a gift card. Devices shown are a demo of the app."
            width={1659}
            height={948}
            fetchPriority="high"
            className={imageClassName}
          />
        </picture>
      </div>

      <aside
        className={proofCardClassName}
        aria-label="Merchant checkout proof highlight"
      >
        <p className="text-[0.72rem] font-semibold uppercase tracking-[0.14em] text-[#a5542d]">
          On the phone you already have
        </p>
        <p className="mt-2 text-lg font-semibold leading-snug text-[#1f1713]">
          {heroPosChoice}
        </p>
        <p className="mt-2 text-sm leading-relaxed text-[#5c4538]">
          Take cards, mix cash and rewards, and book appointments with Tap to
          Pay or an optional Stripe reader. Partner rewards stay optional, with a cap
          you set.
        </p>
      </aside>
    </div>
  );
};

export default HeroDeviceCluster;
